import React, { useState } from "react";
import { Row, Typography } from "antd";
import dayjs from "dayjs";
import {
  DateFilterSelect,
  type DateFilterType,
} from "../../components/DateFilterSelect";
import { RevenueAnalytics } from "../../components/sections/RevenueAnalytics";

const getDefaultDateRange = () => {
  const now = dayjs();
  return {
    from: now.subtract(1, "month").startOf("day").toISOString(),
    to: now.endOf("day").toISOString(),
  };
};

export const RevenuePage: React.FC = () => {
  const [dateFilter, setDateFilter] = useState<DateFilterType>("monthly");
  const [dateRange, setDateRange] = useState(getDefaultDateRange);

  const handleDateChange = (
    filterType: DateFilterType,
    dates?: { from: string; to: string },
  ) => {
    setDateFilter(filterType);
    if (dates) setDateRange(dates);
  };

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <Typography.Title level={4} style={{ margin: 0 }}>
          Revenue
        </Typography.Title>
        <DateFilterSelect value={dateFilter} onChange={handleDateChange} />
      </div>

      <Row gutter={[24, 24]}>
        <RevenueAnalytics dateRange={dateRange} />
      </Row>
    </div>
  );
};
